import { Dropdown } from '@/components/ui'
import { Square, RectangleVertical, RectangleHorizontal } from 'lucide-react'

export type ImageDimension =
  | '1024x1024'
  | '1024x1536'
  | '1536x1024'
  | '864x1536'
  | '1536x864'
  | '960x1280'
  | '1280x960'

interface ImageDimensionsDropdownProps {
  value: ImageDimension
  onChange: (value: ImageDimension) => void
  disabled?: boolean
}

const options = [
  { value: '1024x1024', label: '1:1', description: 'Square', icon: <Square className="size-4" /> },
  { value: '1024x1536', label: '2:3', description: 'Portrait', icon: <RectangleVertical className="size-4" /> },
  { value: '1536x1024', label: '3:2', description: 'Landscape', icon: <RectangleHorizontal className="size-4" /> },
  { value: '864x1536', label: '9:16', description: 'Tall Portrait', icon: <RectangleVertical className="size-4" /> },
  { value: '1536x864', label: '16:9', description: 'Wide Landscape', icon: <RectangleHorizontal className="size-4" /> },
  { value: '960x1280', label: '3:4', description: 'Classic Portrait', icon: <RectangleVertical className="size-4" /> },
  { value: '1280x960', label: '4:3', description: 'Classic Landscape', icon: <RectangleHorizontal className="size-4" /> },
]

export function ImageDimensionsDropdown({ value, onChange, disabled }: ImageDimensionsDropdownProps) {
  return (
    <Dropdown
      label="Aspect Ratio"
      value={value}
      onChange={(val) => onChange(val as ImageDimension)}
      options={options}
      disabled={disabled}
    />
  )
}
